module.exports = __webpack_public_path__ + "img/diapositiva-4-4.300602a3.png";